import { Response } from 'miragejs';
import { StatusCodes as HTTP } from 'http-status-codes';

export default server => {
    server.get('/v1/admin/business_profiles', schema => {
        const { models } = schema.businessProfiles.all();

        return models;
    });

    server.post('/v1/admin/business_profiles', (schema, { requestBody: formData }) => {
        const name = formData.get('name');
        let logo = formData.get('logo');

        if (logo && typeof logo !== 'string') {
            logo = URL.createObjectURL(logo);
        }

        const { attrs } = schema.businessProfiles.create({
            name,
            logo,
            created_at: new Date()
        });

        return attrs;
    });

    server.patch('/v1/admin/business_profiles/:id', (schema, { params: { id }, requestBody: formData }) => {
        const profile = schema.businessProfiles.find(id);

        if (!profile) {
            return new Response(HTTP.NOT_FOUND);
        }

        const name = formData.get('name');
        const logo = formData.get('logo');

        const data = {
            name
        };

        if (logo && typeof logo !== 'string') {
            data.logo = URL.createObjectURL(logo);
        }

        profile.update(data);

        return profile.attrs;
    });
};
